import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip';
// import user from '../../../static/images/user.jpg'
import user from '../../../assets/images/user.jpg'
import { MdArrowForwardIos } from 'react-icons/md'
import { CertAchievedIcon, CertPendingIcon } from '../../../assets/icons/iconshere'
import { useSelector } from 'react-redux';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const ActiveCourses = ({ modules, loading }) => {
    const userData = useSelector((state) => state.userSlice);
    const navigate = useNavigate();

    const handleMyLearning = (e) => {
        navigate(`/course/details/${e.uuid}`, {
          state: {
            name: e.name || "",
            userUUID: userData?.user?.uuid || "",
            previousLocationPathname: null,
          },
        });
      };


    return (
        <>  
            { modules.map ? 
            <div className='cardbox activecourses mt-3'>
                <div className='d-flex justify-content-between'>
                    <h5>  {loading ?  <Skeleton width="5vw" />  : <> Active Courses </> } </h5>
                    {loading ?  <Skeleton width="5vw" />  : <> <Link className='text-secondary' to="/courses"> View All <MdArrowForwardIos /> </Link> </>} 
                </div>
                <div className="row">

                {loading ?
                <>
                <div className="col-md-4">
                    <div className="cardbox child bg-light">
                         <h6 className='mb-1'> <Skeleton width="5vw" /></h6>
                            <p> <Skeleton width="5vw" /> </p>
                                <div className='d-flex align-items-center justify-content-between'>
                                <button className='btn btn-sm btn-danger mb-0'>  <Skeleton width="100px" baseColor="#3e4095" highlightColor="#ffffff50"/></button>
                                </div>
                            </div>
                        </div>
                <div className="col-md-4">
                    <div className="cardbox child bg-light">
                         <h6 className='mb-1'> <Skeleton width="5vw" /></h6>
                            <p> <Skeleton width="5vw" /> </p>
                                <div className='d-flex align-items-center justify-content-between'>
                                <button className='btn btn-sm btn-danger mb-0'>  <Skeleton width="100px" baseColor="#3e4095" highlightColor="#ffffff50"/></button>
                                </div>
                            </div>
                        </div>
                <div className="col-md-4">
                    <div className="cardbox child bg-light">
                         <h6 className='mb-1'> <Skeleton width="5vw" /></h6>
                            <p> <Skeleton width="5vw" /> </p>
                                <div className='d-flex align-items-center justify-content-between'>
                                <button className='btn btn-sm btn-danger mb-0'>  <Skeleton width="100px" baseColor="#3e4095" highlightColor="#ffffff50"/></button>
                                </div>
                            </div>
                        </div>
                </>
                :
                <>
                    {modules.map((item, index) => {
                        return <div key={index} className="col-md-4">
                            <div className="cardbox child bg-light">
                                <Tooltip title={item.name}> 
                                <h6 className='mb-1'>{item.name}</h6>
                                </Tooltip>
                                {/* <p className='d-flex justify-content-between mb-0'><span>24 Jun 2023  </span> <span>1hrs 42min </span></p> */}
                                {item.progress == 100 ? <p className='certifiedusers'> Certification Achieved <span className='text-success'><CertAchievedIcon /></span> </p>
                                    :
                                    <p className='certifiedusers'> Certification Pending  <span className='text-warning'><CertPendingIcon /></span> </p>
                                }

                                <div className='d-flex align-items-center justify-content-between'>
                                        <button onClick={() => handleMyLearning(item)} className='btn btn-sm btn-primary mb-0'>Open Course <MdArrowForwardIos /> </button>
                                </div>
                            </div>
                        </div>
                    })}
                </>
                }

                </div>
            </div>
            :
            null    
        }
        </>
    )
}

export default ActiveCourses
